module.exports = __webpack_public_path__ + "img/ic-um.343971eb.svg";